import React, { useState, useEffect } from 'react';
import { ref, onValue, off, update, get } from 'firebase/database';
import { db } from '../firebase';

const normalize = (s) =>
  s.toLowerCase()
   .replace(/[ａ-ｚＡ-Ｚ０-９]/g, c => String.fromCharCode(c.charCodeAt(0) - 0xFEE0))
   .replace(/[　 ]+/g, ' ')
   .trim();

const BattleQuizScreen = ({ roomInfo, onFinish }) => {
  const { code, myId, isHost } = roomInfo;
  const [roomData, setRoomData] = useState(null);
  const [inputs, setInputs] = useState({});
  const [myStatus, setMyStatus] = useState('waiting');
  const [missCount, setMissCount] = useState(0);
  const [showAnswer, setShowAnswer] = useState(false);
  const [pauseRequested, setPauseRequested] = useState(false);

  useEffect(() => {
    const roomRef = ref(db, `battleRooms/${code}`);
    const unsub = onValue(roomRef, snap => {
      const data = snap.val();
      if (!data) return;
      setRoomData(data);
      if (data.status === 'finished') onFinish(data);
      if (data.pauseVotes) {
        const totalPlayers = Object.keys(data.players || {}).length;
        const votes = Object.keys(data.pauseVotes).length;
        if (votes >= totalPlayers) onFinish(data);
      }
    });
    return () => off(roomRef, 'value', unsub);
  }, [code]);
// 既存のuseEffectとは別に追加
useEffect(() => {
  setMyStatus('waiting');
  setShowAnswer(false);
  setInputs({});
  setMissCount(0);
}, []); // マウント時一回だけ
  useEffect(() => {
    setInputs({});
    setMyStatus('waiting');
    setMissCount(0);
    setShowAnswer(false);
    setPauseRequested(false);
  }, [roomData?.currentIndex]);

  useEffect(() => {
    if (!roomData || !isHost) return;
    const players = Object.keys(roomData.players || {});
    const answers = roomData.answers?.[roomData.currentIndex] || {};
    const answeredCount = Object.keys(answers).length;
    if (players.length > 0 && answeredCount >= players.length) {
      const timer = setTimeout(() => handleNext(), 3000);
      return () => clearTimeout(timer);
    }
  }, [roomData]);

  const handleSubmit = async () => {
    if (myStatus === 'correct' || myStatus === 'giveup' || myStatus === 'answered') return;
    const currentQ = roomData.questions[roomData.currentIndex];
    const correctAnswers = [...currentQ.q.matchAll(/【([^】]+)】/g)].map(m => m[1]);
    // 変更後
const blankCount = (currentQ.q.match(/【[^】]+】/g) || []).length;

    let isCorrect = true;
    for (let i = 0; i < blankCount; i++) {
      const userInput = normalize(inputs[i] || '');
      const correct = normalize(correctAnswers[i] || correctAnswers[0]);
      if (!userInput || (!correct.includes(userInput) && !userInput.includes(correct))) {
        isCorrect = false;
        break;
      }
    }

    if (isCorrect) {
      const answersSnap = await get(ref(db, `battleRooms/${code}/answers/${roomData.currentIndex}`));
      const existingAnswers = answersSnap.val() || {};
      const correctCount = Object.values(existingAnswers).filter(a => a.correct).length;
      const point = Math.max(roomData.playerCount - correctCount, 1);

      await update(ref(db, `battleRooms/${code}/answers/${roomData.currentIndex}`), {
        [myId]: { correct: true, point, name: roomData.players[myId].name, time: Date.now() }
      });
      await update(ref(db, `battleRooms/${code}/players/${myId}`), {
        score: (roomData.players[myId].score || 0) + point
      });
      setMyStatus('correct');
      setShowAnswer(true);
    } else {
      if (missCount >= 1) {
        await update(ref(db, `battleRooms/${code}/answers/${roomData.currentIndex}`), {
          [myId]: { correct: false, point: 0, name: roomData.players[myId].name, time: Date.now() }
        });
        setMyStatus('answered');
        setShowAnswer(true);
      } else {
        setMissCount(1);
        setMyStatus('wrong');
        setTimeout(() => setMyStatus('waiting'), 1500);
      }
    }
  };

  const handleGiveup = async () => {
    if (myStatus !== 'waiting' && myStatus !== 'wrong') return;
    await update(ref(db, `battleRooms/${code}/answers/${roomData.currentIndex}`), {
      [myId]: { correct: false, point: 0, name: roomData.players[myId].name, time: Date.now(), giveup: true }
    });
    setMyStatus('giveup');
    setShowAnswer(true);
  };

  const handleNext = async () => {
    if (!isHost || !roomData) return;
    const nextIndex = roomData.currentIndex + 1;
    if (nextIndex >= roomData.questions.length) {
      await update(ref(db, `battleRooms/${code}`), { status: 'finished' });
    } else {
      await update(ref(db, `battleRooms/${code}`), {
        currentIndex: nextIndex,
        pauseVotes: null,
      });
    }
  };

  const handlePauseVote = async () => {
    if (pauseRequested) return;
    setPauseRequested(true);
    await update(ref(db, `battleRooms/${code}/pauseVotes`), {
      [myId]: true
    });
  };

  if (!roomData || !roomData.questions) {
    return <div style={{ padding: '40px', textAlign: 'center' }}>読み込み中...</div>;
  }

  const currentQ = roomData.questions[roomData.currentIndex];
  const total = roomData.questions.length;
  const current = roomData.currentIndex;
  const players = Object.values(roomData.players || {}).sort((a, b) => b.score - a.score);
  const answers = roomData.answers?.[current] || {};
  const answeredPlayers = Object.values(answers).sort((a, b) => a.time - b.time);
  const allAnswered = Object.keys(answers).length >= Object.keys(roomData.players || {}).length;
const correctAnswers = [...currentQ.q.matchAll(/【([^】]+)】/g)].map(m => m[1]);
const blankCount = correctAnswers.length;
  const pauseVotes = roomData.pauseVotes || {};
  const pauseVoteCount = Object.keys(pauseVotes).length;
  const totalPlayerCount = Object.keys(roomData.players || {}).length;
  const myPauseVoted = !!pauseVotes[myId];

  const getBorderColor = () => {
    if (myStatus === 'correct') return '#2ecc71';
    if (myStatus === 'wrong') return '#e74c3c';
    if (myStatus === 'answered' || myStatus === 'giveup') return '#95a5a6';
    return '#e1e8ed';
  };

  return (
    <div style={{ padding: '16px', maxWidth: '600px', margin: '0 auto', width: '100%', boxSizing: 'border-box' }}>

      {/* スコアボード */}
      <div style={{ display: 'flex', gap: '6px', marginBottom: '12px', justifyContent: 'center', flexWrap: 'wrap' }}>
        {players.map((p, i) => (
          <div key={i} style={{
            background: p.isHost ? '#fef9e7' : '#f8f9fa',
            border: p.isHost ? '2px solid #e67e22' : '2px solid #e1e8ed',
            borderRadius: '12px', padding: '6px 12px', textAlign: 'center', minWidth: '70px'
          }}>
            <div style={{ fontSize: '0.7rem', color: '#7f8c8d' }}>{p.name}</div>
            <div style={{ fontSize: '1.2rem', fontWeight: '900', color: '#e67e22' }}>{p.score || 0}pt</div>
          </div>
        ))}
      </div>

      {/* 進捗 + 中断ボタン */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
        <span style={{ fontSize: '0.8rem', color: '#7f8c8d', fontWeight: 'bold' }}>
          Q{current + 1} / {total}
        </span>
        <button
          onClick={handlePauseVote}
          disabled={myPauseVoted}
          style={{
            padding: '6px 14px', borderRadius: '20px', fontSize: '0.75rem', fontWeight: 'bold',
            border: `2px solid ${myPauseVoted ? '#bdc3c7' : '#e74c3c'}`,
            background: myPauseVoted ? '#f8f9fa' : 'white',
            color: myPauseVoted ? '#bdc3c7' : '#e74c3c',
            cursor: myPauseVoted ? 'not-allowed' : 'pointer',
          }}>
          {myPauseVoted
            ? `中断待ち (${pauseVoteCount}/${totalPlayerCount})`
            : '⏸ 中断を提案'}
        </button>
      </div>

      {/* 中断投票状況 */}
      {pauseVoteCount > 0 && (
        <div style={{
          background: '#fef9e7', border: '1px solid #f39c12', borderRadius: '10px',
          padding: '10px 14px', marginBottom: '10px', fontSize: '0.8rem', color: '#e67e22', fontWeight: 'bold'
        }}>
          ⏸ 中断の提案中... {pauseVoteCount}/{totalPlayerCount}人が同意
          {!myPauseVoted && (
            <button onClick={handlePauseVote}
              style={{ marginLeft: '10px', padding: '4px 10px', borderRadius: '10px', border: 'none', background: '#e67e22', color: 'white', cursor: 'pointer', fontWeight: 'bold', fontSize: '0.75rem' }}>
              同意する
            </button>
          )}
        </div>
      )}

      {/* 問題カード */}
      <div style={{
        background: 'rgba(255,255,255,0.95)',
        backdropFilter: 'blur(10px)',
        borderRadius: '24px',
        border: '1px solid rgba(255,255,255,0.3)',
        boxShadow: '0 20px 50px rgba(149,157,165,0.1)',
        padding: '20px',
        width: '100%',
        boxSizing: 'border-box',
        textAlign: 'left',
        marginBottom: '12px',
      }}>
        <div style={{ fontSize: '0.75rem', color: '#3498db', marginBottom: '8px' }}>
          {currentQ.ch} - {currentQ.s}
        </div>

        {/* 問題文 */}
        <div style={{ fontSize: '1.1rem', lineHeight: '1.8', marginBottom: '16px' }}>
{currentQ.q.split(/【[^】]+】/).map((part, i, arr) => (
  <React.Fragment key={i}>
    {part}
    {i < arr.length - 1 && (
      <span style={{
        display: 'inline-block', minWidth: '60px',
        borderBottom: '3px solid #3498db', color: '#3498db',
        textAlign: 'center', margin: '0 3px',
        fontWeight: 'bold', fontSize: '0.9rem',
      }}>
        ({String.fromCharCode(65 + i)})
      </span>
    )}
  </React.Fragment>
))}
        </div>

        {/* 正解表示 */}
        {showAnswer && (
          <div style={{
            background: '#f8f9fa', padding: '12px', borderRadius: '10px',
            borderLeft: `5px solid ${myStatus === 'correct' ? '#2ecc71' : '#e74c3c'}`,
            marginBottom: '12px', fontSize: '0.9rem'
          }}>
            <strong>正解：</strong>
            {correctAnswers.map((ans, i) => (
              <span key={i}>
                {blankCount > 1 && (
                  <span style={{ color: '#3498db', fontWeight: 'bold' }}>
                    ({String.fromCharCode(65 + i)})&nbsp;
                  </span>
                )}
                {ans}
                {i < correctAnswers.length - 1 ? '　' : ''}
              </span>
            ))}
          </div>
        )}

        {/* 入力エリア（ホスト・参加者共通） */}
        {myStatus === 'waiting' || myStatus === 'wrong' ? (
          <div>
            {myStatus === 'wrong' && (
              <p style={{ color: '#e74c3c', fontSize: '0.8rem', marginBottom: '6px' }}>
                ❌ 不正解！あと1回チャンスがあります
              </p>
            )}
            {Array.from({ length: blankCount }).map((_, i) => (
              <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
                <span style={{
                  minWidth: '28px', height: '28px', borderRadius: '6px',
                  background: '#ebf5fb', color: '#3498db',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontWeight: 'bold', fontSize: '0.85rem', flexShrink: 0,
                }}>
                  {String.fromCharCode(65 + i)}
                </span>
                <input
                  type="text"
                  value={inputs[i] || ''}
                  onChange={e => setInputs(prev => ({ ...prev, [i]: e.target.value }))}
                  onKeyDown={e => e.key === 'Enter' && i === blankCount - 1 && handleSubmit()}
                  placeholder={`(${String.fromCharCode(65 + i)})の答え`}
                  autoFocus={i === 0}
                  style={{
                    flex: 1, padding: '10px 12px', borderRadius: '10px',
                    border: `2px solid ${myStatus === 'wrong' ? '#e74c3c' : '#e1e8ed'}`,
                    fontSize: '0.95rem', outline: 'none', boxSizing: 'border-box',
                  }}
                />
              </div>
            ))}
            <div style={{ display: 'flex', gap: '8px', marginTop: '4px' }}>
              <button onClick={handleSubmit}
                style={{ flex: 2, padding: '12px', background: '#3498db', color: 'white', border: 'none', borderRadius: '10px', cursor: 'pointer', fontWeight: 'bold', fontSize: '0.9rem' }}>
                送信
              </button>
              <button onClick={handleGiveup}
                style={{ flex: 1, padding: '12px', background: '#f8f9fa', border: '2px solid #e1e8ed', borderRadius: '10px', cursor: 'pointer', color: '#7f8c8d', fontWeight: 'bold', fontSize: '0.85rem' }}>
                🏳️ パス
              </button>
            </div>
          </div>
        ) : (
          <div style={{
            padding: '16px', borderRadius: '10px', textAlign: 'center',
            background: myStatus === 'correct' ? '#eafaf1' : '#fdfefe',
            border: `2px solid ${getBorderColor()}`
          }}>
            {myStatus === 'correct' && <p style={{ color: '#2ecc71', fontWeight: 'bold', fontSize: '1.1rem', margin: 0 }}>🎉 正解！</p>}
            {myStatus === 'giveup' && <p style={{ color: '#95a5a6', fontWeight: 'bold', margin: 0 }}>🏳️ パスしました</p>}
            {myStatus === 'answered' && <p style={{ color: '#e74c3c', fontWeight: 'bold', margin: 0 }}>❌ 不正解</p>}
            <p style={{ color: '#7f8c8d', fontSize: '0.85rem', margin: '6px 0 0 0' }}>他の人の回答を待っています...</p>
          </div>
        )}
      </div>

      {/* 回答状況 */}
      {answeredPlayers.length > 0 && (
        <div style={{ marginBottom: '12px' }}>
          <p style={{ fontSize: '0.75rem', color: '#7f8c8d', marginBottom: '6px' }}>回答状況</p>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
            {answeredPlayers.map((a, i) => (
              <div key={i} style={{
                padding: '4px 10px', borderRadius: '12px', fontSize: '0.8rem', fontWeight: 'bold',
                background: a.correct ? '#eafaf1' : '#fdfefe',
                border: `1px solid ${a.correct ? '#2ecc71' : '#e74c3c'}`,
                color: a.correct ? '#2ecc71' : '#e74c3c'
              }}>
                {a.correct ? `✅ ${a.name} +${a.point}pt` : `❌ ${a.name}`}
              </div>
            ))}
          </div>
        </div>
      )}

      {/* ホストの次へボタン */}
      {isHost && (
        <button onClick={handleNext}
          style={{
            width: '100%', padding: '14px',
            background: allAnswered ? '#e67e22' : '#bdc3c7',
            color: 'white', border: 'none', borderRadius: '12px',
            fontWeight: 'bold', cursor: 'pointer', fontSize: '1rem'
          }}>
          {allAnswered
            ? (current + 1 === total ? '🏆 結果発表！' : '次の問題へ →')
            : `回答待ち (${Object.keys(answers).length}/${Object.keys(roomData.players).length}人)`}
        </button>
      )}
    </div>
  );
};

export default BattleQuizScreen;